"use client"

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { Button } from "@/components/ui/button"
import { AlertCircle } from "lucide-react"
import { useErrorCapture } from "@/lib/hooks/useErrorCapture"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useErrorCapture(error, "home")

  return (
    <Alert variant="destructive" className="mt-4">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>Something went wrong!</AlertTitle>
      <AlertDescription>
        An error occurred while loading this page.
        <Button
          variant="secondary"
          size="sm"
          onClick={() => reset()}
          className="mt-2"
        >
          Try again
        </Button>
      </AlertDescription>
    </Alert>
  )
}
